<template>
  <div
    v-if="items.length"
    class="price-equipment d-flex ga-4 overflow-x-auto pb-1"
    data-qa="lpu_page_price_equipment_list"
  >
    <div
      v-for="item in items"
      :key="item.name"
      class="price-equipment__card flex-shrink-0"
      data-qa="lpu_page_price_equipment_item"
    >
      <v-img
        v-if="item.img?.thumb"
        :src="item.img.thumb"
        width="160"
        height="120"
        class="rounded-20 mb-2"
        cover
        :alt="item.name"
      />
      <div class="text-subtitle-2 text--text">
        {{ item.name }}
      </div>
      <div
        v-if="attributeLabel(item)"
        class="text-body-2 text-secondary--text"
      >
        {{ attributeLabel(item) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DiagnosticEquipment } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/types'

defineProps<{
  items: DiagnosticEquipment[]
}>()

function attributeLabel(item: DiagnosticEquipment) {
  return (item.attributes || [])
    .map(attribute => attribute.name)
    .filter(Boolean)
    .join(', ')
}
</script>

<style scoped lang="scss">
.price-equipment {
  &__card {
    width: 160px;
  }
}
</style>
